import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setStagesLock } from "@/adapters/api";
import { stageKeys } from "../utils/query-keys.ts";

export function useSetStagesLock(constructionId: string | undefined) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (locked: boolean) => {
			if (!constructionId) throw new Error("missing construction");
			return setStagesLock(constructionId, locked);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: stageKeys.list(constructionId),
			});
		},
	});
}
